var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.55946 0H7.303C8.71655 0 9.86246 1.05773 9.86246 2.3625V4.641C9.86246 5.94577 8.71655 7.0035 7.303 7.0035H2.55946C1.14591 7.0035 0 5.94577 0 4.641V2.3625C0 1.05773 1.14591 0 2.55946 0ZM7.303 5.4285C7.77162 5.42284 8.15003 5.07356 8.15615 4.641V2.3625C8.15003 1.92994 7.77162 1.58065 7.303 1.575H2.55946C2.09084 1.58065 1.71243 1.92994 1.70631 2.3625V4.641C1.71243 5.07356 2.09084 5.42284 2.55946 5.4285H7.303Z",
    fill: "#4B4B4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4591 0H19.4405C20.8541 0 22 1.05773 22 2.3625V9.534C22 10.8388 20.8541 11.8965 19.4405 11.8965H15.4591C14.7794 11.8993 14.1266 11.6513 13.646 11.2076C13.1653 10.764 12.8966 10.1614 12.8997 9.534V2.3625C12.8997 1.05773 14.0456 0 15.4591 0ZM19.4405 10.3215C19.9117 10.3215 20.2937 9.96892 20.2937 9.534V2.3625C20.2875 1.92994 19.9091 1.58065 19.4405 1.575H15.4591C14.9879 1.575 14.606 1.92758 14.606 2.3625V9.534C14.6029 9.74372 14.6918 9.94569 14.8524 10.094C15.0131 10.2423 15.2319 10.3244 15.4591 10.3215H19.4405Z",
    fill: "#4B4B4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4592 14.7H19.4405C20.8541 14.7 22 15.7577 22 17.0625V18.6375C22 19.9423 20.8541 21 19.4405 21H15.4592C14.0456 21 12.8997 19.9423 12.8997 18.6375V17.0625C12.8997 15.7577 14.0456 14.7 15.4592 14.7ZM19.4405 19.425C19.9092 19.4193 20.2876 19.0701 20.2937 18.6375V17.0625C20.2876 16.6299 19.9092 16.2807 19.4405 16.275H15.4592C14.988 16.275 14.606 16.6276 14.606 17.0625V18.6375C14.606 19.0724 14.988 19.425 15.4592 19.425H19.4405Z",
    fill: "#4B4B4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.55946 9.7965H7.303C8.71655 9.7965 9.86246 10.8542 9.86246 12.159V18.6375C9.86246 19.9423 8.71655 21 7.303 21H2.55946C1.14591 21 0 19.9423 0 18.6375V12.159C0 10.8542 1.14591 9.7965 2.55946 9.7965ZM7.303 19.425C7.77162 19.4193 8.15003 19.0701 8.15615 18.6375V12.159C8.15003 11.7264 7.77162 11.3772 7.303 11.3715H2.55946C2.09084 11.3772 1.71243 11.7264 1.70631 12.159V18.6375C1.71243 19.0701 2.09084 19.4193 2.55946 19.425H7.303Z",
    fill: "#4B4B4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.de63473226296603bb5fdea9945f3b07.svg";
export { ForwardRef as ReactComponent };